import { CeType } from '#packages/presetApi';
import type { PossibleViewModes } from 'types/documentServices';

export const PAGE_SECTIONS_EDITOR_DATA_NAMESPACE = 'pageSections'; // TODO: move to sectionsUtils

export const BEFORE_SECTIONS_MIGRATION_HISTORY_LABEL =
  'BEFORE_SECTIONS_MIGRATION';

export const enum DEBUG {
  LOG = 'log',
  WARN = 'warn',
  TIME = 'time',
  TIME_END = 'timeEnd',
}

export const enum MigrationOrigin {
  Init = 'init',
  Shadow = 'shadow',
  Navigation = 'navigation',
  QuickNavigation = 'quick_navigation',
  PagesPanelNavigation = 'pages_panel_navigation',
  TPAInstall = 'tpa_install',
  TopBarBanner = 'top_bar_notification',
  ExitPreview = 'exit_preview',
  SiteMenu = 'site_menu',
  CopyPastePage = 'copy_paste_page',
}

export const enum ADIMigrationTrigger {
  OnLoad = 'onload',
  OnDemand = 'ondemand',
  Reminder = 'reminder',
}

export const VIEW_MODES = ['DESKTOP', 'MOBILE'] as PossibleViewModes[];

export const DEFAULT_CONTENT_ROLE = CeType.About;

export const MAX_PAGES_TO_MIGRATE = 50;

export const MIGRATION_TIME_LIMIT = 120000; // 2 minutes

export const MIGRATION_SKIP_LIMIT = 2;

export const MAX_MIGRATIONS_ATTEMPTS_PER_PAGE = 2;
